import React, { useCallback, useState } from "react"

import { PageTitleContext, PageTitleContextValue } from "./context"

export const PageTitleProvider: React.FC = ({ children }) => {
  const [title, setTitle] = useState<string | undefined>()

  const setNewPageTitle = useCallback<PageTitleContextValue["setNewPageTitle"]>(
    (newTitle) => setTitle(newTitle),
    [],
  )

  return (
    <PageTitleContext.Provider value={{ title, setNewPageTitle }}>
      {children}
    </PageTitleContext.Provider>
  )
}
